import React from "react";
import TopNavbar from "./components/TopNavbar/TopNavbar";
import Footer from "./components/footer/footer";
import Navbar from "./components/navbar/navbar";
import View from './components/ViewProfile/view'
import Sidebar from "./components/sidebar/sidebar";
import DashboardTobbar from "./components/DashboardTobbar/DashboardTobbar";
const ViewProfilePage = () => {
  return (
    <>
      <DashboardTobbar />
      <Navbar />
      <div className="row m-0 all-profile-layout">
        <div className="col-xl-2 col-lg-3 col-md-12 ps-0 sidebar-col">
          <Sidebar />
        </div>
        <div className="col-xl-10 col-lg-9 col-md-12 px-0 profiles-col">
          <View />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ViewProfilePage;
